import { searchResult } from "organized";

export class productScreenData extends searchResult<any> {
  allowExportProductList: boolean;
  isReadOnly: boolean;
  allowCreateRequest: boolean;

  constructor(item: productScreenData) {
    super(item);
    this.allowExportProductList = item.allowExportProductList;
    this.isReadOnly = item.isReadOnly;
    this.allowCreateRequest = item.allowCreateRequest;
  }
}
